import * as St from './ToolbarItem.styles';

import { TOOLBAR } from '~/core/enums';
import DuplicateIcon from '~assets/icons/Copy button.svg';
import RedoIcon from '~assets/icons/Redo.svg';
import RotateClockwiseIcon from '~assets/icons/Rotate Clockwise.svg';
import RotateCounterClockwiseIcon from '~assets/icons/Rotate Counter Clockwise.svg';
import UndoIcon from '~assets/icons/Undo.svg';
import ZoomInIcon from '~assets/icons/Zoom In.svg';
import ZoomOutIcon from '~assets/icons/Zoom Out.svg';
import ZoomToFitIcon from '~assets/icons/Zoom to Fit.svg';
import RemoveIcon from '~assets/icons/delete.svg';

type ToolbarItemProps = {
  name: TOOLBAR;
  isEnabled: boolean;
  onClick: () => void;
};

const ToolbarItem = ({
  name,
  isEnabled,
  onClick,
}: ToolbarItemProps): JSX.Element => {
  const Icon = buttons[name];

  return (
    <St.Container disabled={!isEnabled} onClick={() => isEnabled && onClick()}>
      <Icon />
    </St.Container>
  );
};

const buttons: Record<TOOLBAR, React.ComponentType> = {
  [TOOLBAR.UNDO]: UndoIcon,
  [TOOLBAR.REDO]: RedoIcon,
  [TOOLBAR.ROTATE_CLOCKWISE]: RotateClockwiseIcon,
  [TOOLBAR.ROTATE_COUNTERCLOCKWISE]: RotateCounterClockwiseIcon,
  [TOOLBAR.DUPLICATE]: DuplicateIcon,
  [TOOLBAR.REMOVE]: RemoveIcon,
  [TOOLBAR.ZOOM_IN]: ZoomInIcon,
  [TOOLBAR.ZOOM_OUT]: ZoomOutIcon,
  [TOOLBAR.ZOOM_TO_FIT]: ZoomToFitIcon,
};

export default ToolbarItem;
